import React, { useCallback, useEffect } from "react";
import { connect } from "react-redux";

import Divider from "antd/es/divider";
import Tooltip from "antd/es/tooltip";
import { FormattedMessage, useIntl } from "react-intl";

import { StageSummary } from "@mapmycustomers/shared/types/entity/deals/StageSummary";
import { Button } from "@mapmycustomers/ui";

import {
  getListViewFunnelStagesSummary,
  getListViewFunnelStagesSummaryLoading,
} from "@app/scene/deal/store";
import { fetchFunnelStagesSummary, toggleFunnelChartDisplay } from "@app/scene/deal/store/actions";
import { RootState } from "@app/store/rootReducer";

import FunnelChart from "./FunnelChart";
import styles from "./FunnelChartContainer.module.scss";

interface Props {
  fetchFunnelStagesSummary: typeof fetchFunnelStagesSummary.request;
  funnelId: number;
  loading: boolean;
  stagesSummary: StageSummary[];
  toggleFunnelChartDisplay: typeof toggleFunnelChartDisplay;
}

const FunnelChartContainer: React.FC<Props> = ({
  fetchFunnelStagesSummary,
  funnelId,
  loading,
  stagesSummary,
  toggleFunnelChartDisplay,
}) => {
  const intl = useIntl();
  const handleHideFunnelChart = useCallback(() => {
    toggleFunnelChartDisplay(true);
  }, [toggleFunnelChartDisplay]);

  useEffect(() => {
    fetchFunnelStagesSummary(funnelId);
  }, [fetchFunnelStagesSummary, funnelId]);

  return (
    <div className={styles.container}>
      <Tooltip
        placement="bottomRight"
        title={
          <div>
            <div className={styles.tooltipTitle}>
              <span>
                <FormattedMessage
                  id="deals.hideFunnelChart.tooltip.title"
                  defaultMessage="Hide funnel visualization?"
                  description="List deal view. Hide funnel chart button tooltip title"
                />
              </span>
            </div>
            <Divider className={styles.tooltipDivider} />
            <div className={styles.tooltipText}>
              <FormattedMessage
                id="deals.hideFunnelChart.tooltip.text"
                defaultMessage="You can always switch this back on by clicking the cog icon in the top right"
                description="List deal view. Hide funnel chart button tooltip text"
              />
            </div>
          </div>
        }
      >
        <Button className={styles.hideButton} onClick={handleHideFunnelChart} type="text">
          {intl.formatMessage({
            id: "deals.hideFunnelChart.button",
            defaultMessage: "Hide funnel",
            description: "Label for hide funnel chart button",
          })}
        </Button>
      </Tooltip>
      <FunnelChart loading={loading} stagesSummary={stagesSummary} />
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  loading: getListViewFunnelStagesSummaryLoading(state),
  stagesSummary: getListViewFunnelStagesSummary(state),
});

const mapDispatchToProps = {
  fetchFunnelStagesSummary: fetchFunnelStagesSummary.request,
  toggleFunnelChartDisplay,
};

export default connect(mapStateToProps, mapDispatchToProps)(FunnelChartContainer);
